import React, { CSSProperties, useMemo } from "react";
import TextWithPrecisionAndIcon, {
  TextWithPrecisionAndIconProps,
} from "common/Text/TextWithPrecisionAndIcon";
import TextWithPrecision from "common/Text/TextWithPrecision";
import { SharedLiveSymbolPriceProps } from "@shared/services/socket/types";
import useLiveSymbolPrice from "@shared/common/LiveComponents/useLiveSymbolPrice";

interface LiveSymbolPriceProps
  extends Omit<SharedLiveSymbolPriceProps, "fontSize"> {
  textProps?: TextWithPrecisionAndIconProps;
  style?: CSSProperties;
  fontSize?: string | number;
}

const LiveSymbolPrice = ({
  symbol,
  exchange,
  initialPrice,
  textColor,
  fontSize,
  textProps,
  hideIcon = false,
  colorValueChange = true,
  style,
}: LiveSymbolPriceProps) => {
  const { props, textStyle } = useLiveSymbolPrice({
    symbol,
    exchange,
    initialPrice,
    textColor,
    fontSize,
    colorValueChange,
  });

  const styleProps = useMemo(
    () => ({ ...style, ...textStyle }),
    [style, textStyle]
  );

  return useMemo(() => {
    return hideIcon ? (
      <div style={styleProps}>
        <TextWithPrecision {...props} />
      </div>
    ) : (
      <TextWithPrecisionAndIcon style={styleProps} {...textProps} {...props} />
    );
  }, [hideIcon, styleProps, props, textProps]);
};

export default LiveSymbolPrice;
